import styled from 'styled-components';

export const Pagination = styled.div``;
